import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { useTheme } from '@design-system/theme';
import { ClearableIconWrapper, StaticIconWrapper } from './IconWrapper';
import { getBoxShadow } from '../utils/getBoxShadow';
export const InputWrapperComponent = forwardRef(({ IconComponent, children, dataTestId, hasError, iconPaddingValue, isClearable, isFocus, onChange, variant, }, ref) => {
    const theme = useTheme();
    const themeInput = theme.input[variant];
    return (_jsxs(InputWrapper, { "$hasError": hasError, "$isFocus": isFocus, "data-testid": dataTestId, children: [IconComponent && (_jsx(StaticIconWrapper, { IconComponent: IconComponent, iconPaddingValue: iconPaddingValue, themeInput: themeInput, variant: variant })), children, isClearable && (_jsx(ClearableIconWrapper, { iconPaddingValue: iconPaddingValue, onChange: onChange, ref: ref, themeInput: themeInput, variant: variant }))] }));
});
const InputWrapper = styled(Box).attrs(({ theme }) => ({
    bg: theme.input.bg,
    height: theme.input.normal.height,
    position: 'relative',
})) `
  border-radius: ${({ theme }) => theme.input.normal.borderRadius}px;
  box-shadow: ${getBoxShadow};

  & input[type='date']::-webkit-inner-spin-button,
  input[type='date']::-webkit-calendar-picker-indicator {
    opacity: 0;
  }
`;
//# sourceMappingURL=InputWrapperComponent.js.map